/**
 * list of Path handled by the application
 */
export class ApplicationConst {
  static uploadPath = 'upload';
  static downloadPath = 'NouveauCourrier';
  static downloadReport = 'customer-request';
  static resetPasswordPath = 'resetPwd';
  static wso2Back = 'auth-callback';
  static logout = 'logout';
}
